import Buttons from "./component/Buttons";
import React from "react";

function App() {
  return (
    <div className="App">
      <Buttons />
    </div>
  );
}

export default App;
